import { PublicKey } from "@solana/web3.js";

/**
 * A TypeScript interface to hold each `PayoutConfig` after parsing.
 */
export interface PayoutConfig {
  dice1: number;
  dice2: number;
  payoutType: number;
  payoutValue: bigint; // or number, but typically large => use bigint
}

/**
 * A TypeScript interface for our full GameState, including the reward map (`payoutMap`).
 */
export interface ParsedGameState {
  admin: PublicKey;
  payoutMap: PayoutConfig[];
}

/**
 * Parse the raw bytes of a GameState account (including the payout_map).
 * 
 * Note:
 *  - We skip the first 8 bytes (Anchor's discriminator).
 *  - Then read 3 Pubkeys (32 bytes each).
 *  - Then read a 4-byte u32 for the length of the `payout_map`.
 *  - Then read each PayoutConfig (11 bytes each).
 */
export function parseGameStateData(data: Buffer): ParsedGameState {
  let offset = 0;

  // 1) Skip Anchor's 8-byte discriminator
  offset += 8;

  // 2) admin (32 bytes)
  const adminBytes = data.slice(offset, offset + 32);
  offset += 32;
  const admin = new PublicKey(adminBytes);

  // 5) payout_map length (4 bytes, LE u32)
  const payoutMapLength = data.readUInt32LE(offset);
  console.log(payoutMapLength)
  offset += 4;

  // 6) Read each PayoutConfig (11 bytes each)
  const payoutMap: PayoutConfig[] = [];
  for (let i = 0; i < payoutMapLength; i++) {
    const dice1 = data[offset];       // 1 byte
    const dice2 = data[offset + 1];   // 1 byte
    const payoutType = data[offset + 2];  // 1 byte
    const payoutValue = data.readBigUInt64LE(offset + 3); // 8 bytes
    offset += 11;

    payoutMap.push({
      dice1,
      dice2,
      payoutType,
      payoutValue,
    });
  }

  return {
    admin,
    payoutMap,
  };
}
